import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    copiedMessage: { type: String, default: "Copied!" },
    copyLabel: { type: String, default: "Copy" }
  }

  connect() {
    this.wrappers = this.element.querySelectorAll(".code-block-wrapper")
    this.wrappers.forEach((wrapper) => this.addCopyButton(wrapper))
  }

  addCopyButton(wrapper) {
    if (wrapper.querySelector(".code-block-header")) return
    const lang = wrapper.querySelector(".code-block-language")
    const codeEl = wrapper.querySelector("pre code, pre")
    if (!codeEl) return

    const header = document.createElement("div")
    header.className = "code-block-header"
    if (lang) {
      lang.parentNode.removeChild(lang)
      header.appendChild(lang)
    }
    const btn = document.createElement("button")
    btn.type = "button"
    btn.className = "code-block-copy"
    btn.textContent = this.copyLabelValue
    btn.setAttribute("aria-label", "Copy code")
    btn.addEventListener("click", () => this.copy(wrapper, btn))
    header.appendChild(btn)
    wrapper.insertBefore(header, wrapper.firstChild)
  }

  copy(wrapper, btn) {
    const codeEl = wrapper.querySelector("pre code, pre")
    if (!codeEl) return
    const text = codeEl.textContent || ""
    const message = this.copiedMessageValue

    navigator.clipboard.writeText(text).then(
      () => {
        btn.textContent = message
        btn.disabled = true
        setTimeout(() => {
          btn.textContent = this.copyLabelValue
          btn.disabled = false
        }, 2000)
      },
      () => {
        btn.textContent = "Failed"
        setTimeout(() => { btn.textContent = this.copyLabelValue }, 1500)
      }
    )
  }
}
